import React from 'react';

const KnownBrandsStep = ({ answers, setAnswers }) => {
  const iranianBrands = [
    'سینره',
    'شون',
    'نئودرم',
    'مای',
    'سی گل',
    'درماسیف',
    'پریم',
    'هیدرودرم',
    'هیراد',
    'گلنار',
    'پارس حیات',
    'آرایشی بهداشتی ایران',
    'کیمیا',
    'زیبایی',
    'آرایشی بهداشتی پارس',
    'سایر'
  ];

  const internationalBrands = [
    'CeraVe',
    'The Ordinary',
    'La Roche-Posay',
    'Vichy',
    'Bioderma',
    'Neutrogena',
    'Paula\'s Choice',
    'L\'Oréal',
    'COSRX',
    'Eucerin',
    'Clinique',
    'Estée Lauder',
    'Lancôme',
    'SK-II',
    'Innisfree',
    'The Face Shop',
    'Drunk Elephant',
    'Glossier',
    'First Aid Beauty',
    'Avene',
    'Vaseline',
    'Nivea',
    'Garnier',
    'Maybelline',
    'سایر'
  ];

  const handleToggleBrand = (brand, isIranian) => {
    const brandType = isIranian ? 'iranian' : 'international';
    const currentBrands = answers.knownBrands?.[brandType] || [];
    
    const updatedBrands = currentBrands.includes(brand)
      ? currentBrands.filter(b => b !== brand)
      : [...currentBrands, brand];
    
    setAnswers({
      ...answers,
      knownBrands: {
        ...answers.knownBrands,
        [brandType]: updatedBrands
      }
    });
  };

  return (
    <div className="text-center">
      <h2 className="text-2xl font-bold mb-8 text-gray-800">
        کدام برندهای ایرانی و خارجی محصولات مراقبت از پوست را می‌شناسید یا استفاده کرده‌اید؟
      </h2>
      
      <div className="mb-8">
        <h3 className="text-lg font-semibold text-gray-700 mb-4 text-right">🇮🇷 برندهای ایرانی</h3>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
          {iranianBrands.map((brand) => (
            <button
              key={brand}
              onClick={() => handleToggleBrand(brand, true)}
              className={`p-3 rounded-md transition-all duration-300 transform hover:scale-105 text-sm ${
                answers.knownBrands?.iranian?.includes(brand)
                  ? 'bg-black text-white'
                  : 'bg-white text-gray-700 border border-gray-200 hover:border-gray-300'
              }`}
            >
              {brand}
            </button>
          ))}
        </div>
      </div>
      
      <div>
        <h3 className="text-lg font-semibold text-gray-700 mb-4 text-right">🌍 برندهای خارجی</h3>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
          {internationalBrands.map((brand) => (
            <button
              key={brand}
              onClick={() => handleToggleBrand(brand, false)}
              className={`p-3 rounded-md transition-all duration-300 transform hover:scale-105 text-sm ${
                answers.knownBrands?.international?.includes(brand)
                  ? 'bg-black text-white'
                  : 'bg-white text-gray-700 border border-gray-200 hover:border-gray-300'
              }`}
            >
              {brand}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default KnownBrandsStep; 